import React from 'react';
import { legalServices, notaryPhotos } from '../mockData';
import { Briefcase, Users, Home, FileText } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  Briefcase: Briefcase,
  Users: Users,
  Home: Home,
  FileText: FileText
};

const About = () => {
  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        {/* About Section */}
        <div className="max-w-4xl mx-auto mb-20">
          <div className="text-center mb-8">
            <p className="text-notaria-secondary font-semibold mb-2 uppercase tracking-wide">Sobre nosotros</p>
            <h2 className="text-4xl md:text-5xl font-bold text-notaria-primary mb-6">
              Notaría Pública 90
            </h2>
          </div>
          <div className="text-gray-700 space-y-4 text-lg leading-relaxed">
            <p>
              La Notaría 90 es la mejor opción en notarías en Quintana Roo.
            </p>
            <p>
              Ofrecemos servicios notariales y asesoría legal con honestidad, integridad y confidencialidad. 
              Analizamos las opciones jurídicas y fiscales más eficientes para cada cliente, garantizando 
              certeza jurídica en cada trámite.
            </p>
            <p>
              Nos enfocamos en la seguridad preventiva, asegurando legalidad, claridad y asesoramiento imparcial 
              para evitar conflictos futuros y mantener un estricto control de calidad.
            </p>
          </div>
        </div>

        {/* Photo Gallery */}
        <div className="max-w-6xl mx-auto mb-20">
          <h3 className="text-3xl font-bold text-center text-notaria-primary mb-8">Nuestras Instalaciones</h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {notaryPhotos.map((photo, index) => (
              <div key={index} className="relative h-80 rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 group">
                <img
                  src={photo}
                  alt={`Notaría 90 - Instalación ${index + 1}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-notaria-primary/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div>

        {/* Legal Services */}
        <div className="max-w-6xl mx-auto">
          <h3 className="text-3xl md:text-4xl font-bold text-center text-notaria-primary mb-12">
            Recibe asesoría completamente personalizada
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {legalServices.map((service, index) => {
              const Icon = iconMap[service.icon];
              return (
                <Card key={index} className="border-2 border-gray-100 hover:border-notaria-secondary transition-all duration-300 hover:shadow-lg group">
                  <CardContent className="p-6 text-center">
                    <div className="w-16 h-16 mx-auto mb-4 rounded-full bg-gray-100 flex items-center justify-center group-hover:bg-notaria-secondary transition-colors duration-300">
                      <Icon className="w-8 h-8 text-notaria-secondary group-hover:text-white transition-colors duration-300" />
                    </div>
                    <h4 className="text-xl font-bold text-gray-900 mb-3">
                      {service.title}
                    </h4>
                    <p className="text-gray-600 text-sm leading-relaxed">
                      {service.description}
                    </p>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>

        {/* CTA Section */}
        <div className="mt-20 text-center">
          <h3 className="text-3xl md:text-4xl font-bold text-notaria-primary mb-4">
            Encuentra la solución adecuada
          </h3>
          <p className="text-xl text-gray-700">Contáctanos</p>
        </div>
      </div>
    </section>
  );
};

export default About;
